import { useSyncExternalStore } from 'react';
import { TimeMs } from '../types';
import { playheadStore } from '../../playback';

/**
 * Reactive read of the playhead. Subscribing to this hook re-renders the
 * component on every frame while playback is running, so use it sparingly —
 * only in components that visually represent time (playhead line, time display).
 */
export const usePlayheadValue = (): TimeMs =>
  useSyncExternalStore(playheadStore.subscribe, playheadStore.get, playheadStore.get);
